(() => {
/**
 * Retrieve postcode and city input of a type
 * 
 * @returns {Object} object of all inputs { postcodeInput, cityInput }
 */ function $d3503d14f601c3ac$export$55934288a7bd011d(type) {
    const postcodeInput = document.getElementById(type + "_postcode") ?? null;
    const cityInput = document.getElementById(type + "_city") ?? null;
    let inputs = {
        postcodeInput: postcodeInput,
        cityInput: cityInput
    };
    return inputs;
}
function $d3503d14f601c3ac$export$42ffc0e3c17f3207(type) {
    const postcodeField = document.getElementById(type + "_postcode_field") ?? null;
    const cityField = document.getElementById(type + "_city_field") ?? null;
    let fields = {
        postcodeField: postcodeField,
        cityField: cityField
    };
    return fields;
}
function $d3503d14f601c3ac$export$1e9062d37edcc9b(inputField) {
    inputField.classList.remove("woocommerce-invalid");
    inputField.classList.remove("woocommerce-invalid-required-field");
    inputField.classList.add("woocommerce-validated");
}
function $d3503d14f601c3ac$export$a390c1a93e1f9e0(inputField) {
    inputField.classList.remove("woocommerce-validated");
    inputField.classList.add("woocommerce-invalid");
    inputField.classList.add("woocommerce-invalid-required-field");
}
function $d3503d14f601c3ac$export$416a29cdd7ae0860(input, inputField) {
    if (input.value === "") return;
    const inputType = localStorage.getItem("sef-shippingType");
    let validation = localStorage.getItem("sef-" + inputType + "-validation") ?? "";
    if (validation === "") $d3503d14f601c3ac$export$1e9062d37edcc9b(inputField);
    if (validation === "warning") $d3503d14f601c3ac$export$1e9062d37edcc9b(inputField);
    if (validation === "error") $d3503d14f601c3ac$export$a390c1a93e1f9e0(inputField);
}
function $d3503d14f601c3ac$export$d395e3b20a2c5108(input, field, value) {
    if (input.value === "") {
        input.setAttribute("value", value);
        input.value = value;
        $d3503d14f601c3ac$export$1e9062d37edcc9b(field);
    }
}
function $d3503d14f601c3ac$export$5b9f1f3747c67720(inputField) {
    inputField.classList.add("blockUI");
    inputField.classList.add("blockOverlay");
}
function $d3503d14f601c3ac$export$90e92d396331582f(inputField) {
    inputField.classList.remove("blockUI");
    inputField.classList.remove("blockOverlay");
}
function $d3503d14f601c3ac$export$c4f94c8b3850a5a9(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
function $d3503d14f601c3ac$export$8a9265511836bab8(errorText, inputField, input) {
    let errorMsg = document.getElementById("sef-checkout-" + inputField.id + "-error-message");
    if (errorText != "") {
        if (errorMsg === null) {
            errorMsg = document.createElement("p");
            errorMsg.setAttribute("id", "sef-checkout-" + inputField.id + "-error-message");
            $d3503d14f601c3ac$export$c4f94c8b3850a5a9(input.parentElement, errorMsg);
        }
        errorMsg.innerText = errorText;
        return errorMsg;
    } else if (errorText === "" && errorMsg != null) errorMsg.remove();
    return false;
}
function $d3503d14f601c3ac$export$7c181a3c384c0dd7(errorMsg) {
    if (errorMsg) errorMsg.setAttribute("class", "sef-checkout-error-message");
}
function $d3503d14f601c3ac$export$e5a6cf285b66d896(errorMsg) {
    if (errorMsg) errorMsg.setAttribute("class", "sef-checkout-warning-message");
}



let $884f5d1790766d91$var$timer;
document.addEventListener("DOMContentLoaded", ()=>{
    const inputType = localStorage.getItem("sef-shippingType") ?? "billing";
    const inputs = (0, $d3503d14f601c3ac$export$55934288a7bd011d)(inputType);
    localStorage.setItem("sef-" + inputType + "-prevPostcode", inputs?.postcodeInput?.value ?? "");
    localStorage.setItem("sef-" + inputType + "-location", inputs?.cityInput?.value ?? "");
});
function $884f5d1790766d91$export$4cd236e0b2e0f3de(type) {
    clearTimeout($884f5d1790766d91$var$timer);
    localStorage.setItem("sef-shippingType", type);
    let changedPostcode = $884f5d1790766d91$export$515c75344f34ce63();
    if (changedPostcode) {
        $884f5d1790766d91$export$cca3bbc6042c14da(true);
        $884f5d1790766d91$var$timer = setTimeout($884f5d1790766d91$export$237faf92becec7bb, 750);
    // setTimeout(setPostcodeLoading(true), 500);
    // timer = setTimeout(sendPostcodeRequest, 750);
    }
}
async function $884f5d1790766d91$export$237faf92becec7bb() {
    return new Promise((resolve, reject)=>{
        const inputType = localStorage.getItem("sef-shippingType");
        const inputs = (0, $d3503d14f601c3ac$export$55934288a7bd011d)(inputType);
        const fields = (0, $d3503d14f601c3ac$export$42ffc0e3c17f3207)(inputType);
        const postcodeInput = inputs.postcodeInput;
        const postcodeField = fields.postcodeField;
        const cityInput = inputs.cityInput;
        const cityField = fields.cityField;
        if (!postcodeInput) {
            reject("Postcode input does not exist");
            return;
        }
        const postcode = postcodeInput.value;
        if (postcode.length != 4) {
            let prevPostcodeLength = localStorage.getItem("sef-" + inputType + "-prevPostcodeLength");
            (0, $d3503d14f601c3ac$export$a390c1a93e1f9e0)(postcodeField);
            localStorage.setItem("sef-" + inputType + "-validation", "error");
            $884f5d1790766d91$export$de51e7cbfd78307d();
            if (prevPostcodeLength == 4) $884f5d1790766d91$export$c0756767ae94e698(inputType);
            localStorage.setItem("sef-" + inputType + "-prevPostcodeLength", 0);
            return;
        }
        jQuery.ajax({
            url: sef_validate_checkout_postcode.ajax_url,
            type: "post",
            data: {
                _ajax_nonce: sef_validate_checkout_postcode.nonce,
                action: "sef_postcodeExist",
                postcode: postcode
            }
        }).done(function(response) {
            // Creates a variable to check which validation to use.
            let validation = "";
            // Creates a variable to check if location should be validated.
            let location = "";
            try {
                if (postcode === "") {
                    validation = "error";
                    throw "";
                }
                if ("exist" in response && !response.exist) {
                    validation = "error";
                    throw "postcode not exist";
                }
                if ("weight" in response && !response.weight) {
                    validation = "warning";
                    location = response.location;
                    throw "too heavy for posten";
                }
                if ("price" in response && !response.price) {
                    validation = "warning";
                    throw "no dsv";
                }
                $884f5d1790766d91$export$de51e7cbfd78307d();
                location = response.location;
                (0, $d3503d14f601c3ac$export$1e9062d37edcc9b)(cityField);
                (0, $d3503d14f601c3ac$export$1e9062d37edcc9b)(postcodeField);
            } catch (error) {
                localStorage.setItem("sef-" + inputType + "-validation", validation);
                $884f5d1790766d91$export$611e52258d848177(error);
            }
            localStorage.setItem("sef-" + inputType + "-validation", validation);
            localStorage.setItem("sef-" + inputType + "-location", location);
        }).always(function(response) {
            if ("location" in response) {
                cityInput.setAttribute("value", response.location);
                cityInput.value = response.location;
            }
            $884f5d1790766d91$export$cca3bbc6042c14da(false);
            $884f5d1790766d91$export$c0756767ae94e698(inputType);
            resolve(true);
        });
    });
}
function $884f5d1790766d91$export$e0c23970e9b3361d(errorMsg1) {
    const inputType = localStorage.getItem("sef-shippingType");
    const inputs = (0, $d3503d14f601c3ac$export$55934288a7bd011d)(inputType);
    const fields = (0, $d3503d14f601c3ac$export$42ffc0e3c17f3207)(inputType);
    const postcodeField = fields.postcodeField;
    const cityInput = inputs.cityInput;
    const cityField = fields.cityField;
    (0, $d3503d14f601c3ac$export$a390c1a93e1f9e0)(postcodeField);
    (0, $d3503d14f601c3ac$export$7c181a3c384c0dd7)(errorMsg1);
    cityInput.setAttribute("value", "");
    cityInput.value = "";
    (0, $d3503d14f601c3ac$export$a390c1a93e1f9e0)(cityField);
}
function $884f5d1790766d91$export$af6f8f3a490de029(errorMsg1) {
    const inputType = localStorage.getItem("sef-shippingType");
    const fields = (0, $d3503d14f601c3ac$export$42ffc0e3c17f3207)(inputType);
    const postcodeField = fields.postcodeField;
    const cityField = fields.cityField;
    (0, $d3503d14f601c3ac$export$1e9062d37edcc9b)(postcodeField);
    (0, $d3503d14f601c3ac$export$1e9062d37edcc9b)(cityField);
    (0, $d3503d14f601c3ac$export$e5a6cf285b66d896)(errorMsg1);
}
function $884f5d1790766d91$export$de51e7cbfd78307d() {
    errorMsg = document.getElementById("sef-checkout-billing_postcode_field-error-message");
    if (errorMsg != null) errorMsg.remove();
}
function $884f5d1790766d91$export$b6a2c53e325c71f7(errorMsg1) {
    const inputType = localStorage.getItem("sef-shippingType");
    let validation = localStorage.getItem("sef-" + inputType + "-validation") ?? "";
    if (validation === "error") $884f5d1790766d91$export$e0c23970e9b3361d(errorMsg1);
    if (validation === "warning") $884f5d1790766d91$export$af6f8f3a490de029(errorMsg1);
}
function $884f5d1790766d91$export$611e52258d848177(error) {
    const inputType = localStorage.getItem("sef-shippingType");
    const inputs = (0, $d3503d14f601c3ac$export$55934288a7bd011d)(inputType);
    const fields = (0, $d3503d14f601c3ac$export$42ffc0e3c17f3207)(inputType);
    const postcodeInput = inputs.postcodeInput;
    const postcodeField = fields.postcodeField;
    let errorText = "";
    if (error === "postcode not exist") errorText = sef_validate_checkout_postcode.postCodeNotFound;
    if (error === "too heavy for posten") errorText = sef_validate_checkout_postcode.postTooHeavy;
    if (error === "no dsv") errorText = sef_validate_checkout_postcode.dsvNoShipping;
    errorMsg = (0, $d3503d14f601c3ac$export$8a9265511836bab8)(errorText, postcodeField, postcodeInput);
    $884f5d1790766d91$export$b6a2c53e325c71f7(errorMsg);
}
function $884f5d1790766d91$export$cca3bbc6042c14da(value) {
    const inputType = localStorage.getItem("sef-shippingType");
    const inputs = (0, $d3503d14f601c3ac$export$55934288a7bd011d)(inputType);
    const fields = (0, $d3503d14f601c3ac$export$42ffc0e3c17f3207)(inputType);
    const cityInput = inputs.cityInput;
    const postcodeField = fields.postcodeField;
    const postcodeInput = inputs.postcodeInput;
    if (!value || postcodeInput.value.length != 4) {
        (0, $d3503d14f601c3ac$export$90e92d396331582f)(postcodeField);
        cityInput.removeAttribute("disabled");
        return;
    }
    (0, $d3503d14f601c3ac$export$5b9f1f3747c67720)(postcodeField);
    cityInput.setAttribute("disabled", "disabled");
}
function $884f5d1790766d91$export$515c75344f34ce63() {
    const inputType = localStorage.getItem("sef-shippingType");
    const inputs = (0, $d3503d14f601c3ac$export$55934288a7bd011d)(inputType);
    const fields = (0, $d3503d14f601c3ac$export$42ffc0e3c17f3207)(inputType);
    const postcodeInput = inputs.postcodeInput;
    const cityInput = inputs.cityInput;
    const cityField = fields.cityField;
    let prevPostcode = localStorage.getItem("sef-" + inputType + "-prevPostcode");
    if (prevPostcode === postcodeInput.value) {
        let postcodeLocation = localStorage.getItem("sef-" + inputType + "-location");
        if (cityInput.value === "") {
            cityInput.setAttribute("value", postcodeLocation);
            cityInput.value = postcodeLocation;
            (0, $d3503d14f601c3ac$export$1e9062d37edcc9b)(cityField);
        }
        return false;
    }
    if (prevPostcode.length == 4) localStorage.setItem("sef-" + inputType + "-prevPostcodeLength", prevPostcode.length);
    if (cityInput.value != "") {
        cityInput.setAttribute("value", "");
        cityInput.value = "";
        (0, $d3503d14f601c3ac$export$a390c1a93e1f9e0)(cityField);
    }
    localStorage.setItem("sef-" + inputType + "-prevPostcode", postcodeInput.value);
    return true;
}
function $884f5d1790766d91$export$c0756767ae94e698(type) {
    const shipping = document.getElementById("ship-to-different-address-checkbox");
    if (shipping) {
        if (shipping.checked && type != "shipping") return;
    }
    const inputs = (0, $d3503d14f601c3ac$export$55934288a7bd011d)(type);
    const postcodeInput = inputs.postcodeInput;
    const cityInput = inputs.cityInput;
    // Update price if both inputs are empty
    if (postcodeInput.value != "" && cityInput.value != "") jQuery(document.body).trigger("update_checkout");
    // Update price if both inputs are filled
    if (postcodeInput.value === "" && cityInput.value === "") jQuery(document.body).trigger("update_checkout");
    // Update price if postcode input is filled but city input is empty
    if (postcodeInput.value != "" && cityInput.value === "") jQuery(document.body).trigger("update_checkout");
}


document.addEventListener("DOMContentLoaded", ()=>{
    const billingInputs = (0, $d3503d14f601c3ac$export$55934288a7bd011d)("billing");
    const billingFields = (0, $d3503d14f601c3ac$export$42ffc0e3c17f3207)("billing");
    const shippingInputs = (0, $d3503d14f601c3ac$export$55934288a7bd011d)("shipping");
    const shippingFields = (0, $d3503d14f601c3ac$export$42ffc0e3c17f3207)("shipping");
    let billingPostcodeInput = null;
    let billingPostcodeField = null;
    let shippingPostcodeInput = null;
    let shippingPostcodeField = null;
    if (billingInputs) billingPostcodeInput = billingInputs.postcodeInput;
    if (billingFields) billingPostcodeField = billingFields.postcodeField;
    if (shippingInputs) shippingPostcodeInput = shippingInputs.postcodeInput;
    if (shippingFields) shippingPostcodeField = shippingFields.postcodeField;
    if (billingPostcodeInput && billingPostcodeField) {
        billingPostcodeInput.addEventListener("input", ()=>(0, $884f5d1790766d91$export$4cd236e0b2e0f3de)("billing"), false);
        billingPostcodeInput.addEventListener("blur", ()=>{
            (0, $d3503d14f601c3ac$export$416a29cdd7ae0860)(billingPostcodeInput, billingPostcodeField);
        }, false);
    }
    if (shippingPostcodeInput && shippingPostcodeField) {
        shippingPostcodeInput.addEventListener("input", ()=>(0, $884f5d1790766d91$export$4cd236e0b2e0f3de)("shipping"), false);
        shippingPostcodeInput.addEventListener("blur", ()=>{
            (0, $d3503d14f601c3ac$export$416a29cdd7ae0860)(shippingPostcodeInput, shippingPostcodeField);
        }, false);
    }
});

})();
//# sourceMappingURL=sef-validate-checkout-postcode.js.map
